/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ApiEstimationUserAssignmentType,
  ApiPermission,
  ApiSortUsersBy,
  CreateUserRequest,
  EstimationUserResponsePaginatedResponse,
  UpdateUserRequest,
  UserLatestEstimationResponse,
  UserResponse,
  UserResponsePaginatedResponse,
  UserWithTempPasswordResponse,
  V1EstimationsUsersListError,
  V1UsersCreateError,
  V1UsersCurrentLatestActiveEstimationListError,
  V1UsersCurrentListError,
  V1UsersDeleteError,
  V1UsersDetailError,
  V1UsersListError,
  V1UsersUpdateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class User<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags User
   * @name V1EstimationsUsersList
   * @request GET:/api/v1/estimations/{estimationId}/users
   * @secure
   * @response `200` `EstimationUserResponsePaginatedResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsUsersList = (
    estimationId: string,
    query?: {
      /**
       * Starting from 1
       * @format int32
       * @min 1
       * @max 2147483647
       */
      pageNumber?: number;
      /**
       * @format int32
       * @min 1
       * @max 2147483647
       */
      pageSize?: number;
      sortBy?: ApiSortUsersBy;
      sortAscending?: boolean;
      fulltextSearch?: string;
      type?: ApiEstimationUserAssignmentType;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationUserResponsePaginatedResponse, V1EstimationsUsersListError>({
      path: `/api/v1/estimations/${estimationId}/users`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name V1UsersCurrentList
   * @request GET:/api/v1/users/current
   * @secure
   * @response `200` `UserResponse` OK
   * @response `401` `ProblemDetailsWithErrorCode` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1UsersCurrentList = (params: RequestParams = {}) =>
    this.http.request<UserResponse, V1UsersCurrentListError>({
      path: `/api/v1/users/current`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name V1UsersCurrentLatestActiveEstimationList
   * @request GET:/api/v1/users/current/latest-active-estimation
   * @secure
   * @response `200` `UserLatestEstimationResponse` OK
   * @response `204` `void` No Content
   * @response `401` `ProblemDetailsWithErrorCode` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1UsersCurrentLatestActiveEstimationList = (params: RequestParams = {}) =>
    this.http.request<UserLatestEstimationResponse, V1UsersCurrentLatestActiveEstimationListError>({
      path: `/api/v1/users/current/latest-active-estimation`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name V1UsersDetail
   * @request GET:/api/v1/users/{userId}
   * @secure
   * @response `200` `UserResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1UsersDetail = (userId: string, params: RequestParams = {}) =>
    this.http.request<UserResponse, V1UsersDetailError>({
      path: `/api/v1/users/${userId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name V1UsersUpdate
   * @request PUT:/api/v1/users/{userId}
   * @secure
   * @response `200` `UserResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1UsersUpdate = (userId: string, data: UpdateUserRequest, params: RequestParams = {}) =>
    this.http.request<UserResponse, V1UsersUpdateError>({
      path: `/api/v1/users/${userId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name V1UsersDelete
   * @request DELETE:/api/v1/users/{userId}
   * @secure
   * @response `204` `void` No Content
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1UsersDelete = (userId: string, params: RequestParams = {}) =>
    this.http.request<void, V1UsersDeleteError>({
      path: `/api/v1/users/${userId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name V1UsersList
   * @request GET:/api/v1/users
   * @secure
   * @response `200` `UserResponsePaginatedResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1UsersList = (
    query?: {
      /**
       * Starting from 1
       * @format int32
       * @min 1
       * @max 2147483647
       */
      pageNumber?: number;
      /**
       * @format int32
       * @min 1
       * @max 2147483647
       */
      pageSize?: number;
      sortBy?: ApiSortUsersBy;
      sortAscending?: boolean;
      fulltextSearch?: string;
      permissions?: ApiPermission[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<UserResponsePaginatedResponse, V1UsersListError>({
      path: `/api/v1/users`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name V1UsersCreate
   * @request POST:/api/v1/users
   * @secure
   * @response `200` `UserWithTempPasswordResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1UsersCreate = (data: CreateUserRequest, params: RequestParams = {}) =>
    this.http.request<UserWithTempPasswordResponse, V1UsersCreateError>({
      path: `/api/v1/users`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
